import api from '@/lib/api';

// Cloud Agent (server-side otonom ticket işleme) — web tarafı.
// /api/agent/* artık JWT kabul ediyor (backend resolveOrgAny): admin + agent, kendi JWT'siyle kontrol eder.
// Raw agent-key GEREKMEZ. api instance zaten Authorization header'ı ekliyor.

export interface CloudView {
  id: string;
  name: string;
}

export interface CloudJob {
  id: string;
  status: string; // 'running' | 'stopping' | 'stopped' | 'error'
  view_id?: string | null;
  view_name?: string | null;
  processed?: number;
  drafted?: number;
  noted?: number;
  skipped?: number;
  current_ticket_number?: string | null;
  started_at?: string;
  finished_at?: string | null;
}

export const cloudAgentService = {
  async getViews(): Promise<CloudView[]> {
    const r = await api.get('/agent/views');
    return r.data?.data || [];
  },
  async getStatus(): Promise<CloudJob | null> {
    const r = await api.get('/agent/run');
    return r.data?.data ?? null;
  },
  async start(viewId?: string | null): Promise<{ jobId?: string; already?: boolean }> {
    const r = await api.post('/agent/run', viewId ? { viewId } : {});
    return r.data?.data || {};
  },
  async stop(): Promise<{ stopped?: boolean }> {
    const r = await api.post('/agent/run/x/stop', {});
    return r.data?.data || {};
  },
};

export default cloudAgentService;
